import {
  model,
  Model,
  prop,
  modelAction,
  ModelCreationData,
} from 'mobx-keystone';

@model('bpEwells/SelfVerificationType')
export default class SelfVerificationType extends Model({
  id: prop<number>(),
  name: prop<string>(''),
  isActive: prop<boolean>(),
}) {
  @modelAction
  update(data: ModelCreationData<SelfVerificationType>) {
    Object.assign(this, data);
  }
}
